export interface PersistedEnvelope<T> {
  payload: T;
  checksum: string;
  storedAt: string;
}

export function createEnvelope<T>(payload: T, checksum: string): PersistedEnvelope<T> {
  return {
    payload,
    checksum,
    storedAt: new Date().toISOString(),
  };
}
